/**
 * Converts user+alias@domain.com to user@domain.com
 */
export function getBaseEmail(email: string): string {
  return email.replace(/\+[^@]+@/, '@');
}

export type PrimarySecondaryEmailEquivalenceOptions = {
  /**
   * When true, `user@domain` and `user+alias@domain` are treated as the same address.
   * Keep enabled in production (including AXA prod); disable in non-prod so QA can use
   * plus-aliases for real OTPs.
   * @default true
   */
  treatPlusAliasesAsSame?: boolean;
};

export function arePrimaryAndSecondaryEmailsEquivalent(
  primaryEmail: string,
  secondaryEmail: string,
  options: PrimarySecondaryEmailEquivalenceOptions = {},
): boolean {
  const { treatPlusAliasesAsSame = true } = options;
  const primary = primaryEmail.trim().toLowerCase();
  const secondary = secondaryEmail.trim().toLowerCase();

  if (!treatPlusAliasesAsSame) {
    return primary === secondary;
  }

  return getBaseEmail(primary) === getBaseEmail(secondary);
}
